import { ProductResult } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { SimpleTooltip } from '@shared/components/simple-tooltip';
import ProductIngredientsTable from './product-ingredients-table';

interface ProductDetailIngredientsSectionProps {
  product: ProductResult;
  globalMaxEmissions: number;
}

export default function ProductDetailIngredientsSection({
  product,
  globalMaxEmissions,
}: ProductDetailIngredientsSectionProps) {
  const {
    totalIngredientWeight,
    ingredientShareOfTotalEmissions,
    ingredients,
  } = product;

  const displayWeight = product.netWeight ?? totalIngredientWeight;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Text variant="cardTitle" className="text-primary-900">
          Recipe
        </Text>
        <div className="flex space-x-6">
          <span className="flex items-center space-x-1">
            <Icons.scale size={16} />
            <SimpleTooltip
              side="top"
              trigger={
                <span className="cursor-default text-right text-sm text-gray-600 underline decoration-dotted">
                  {(displayWeight ?? 0).toFixed(1)} kg
                </span>
              }
              content={
                <div className="flex flex-col gap-1">
                  {product.netWeight != null && (
                    <span className="text-xs">
                      Net weight: {product.netWeight.toFixed(1)} kg
                    </span>
                  )}
                  <span className="text-xs">
                    Total ingredient weight:{' '}
                    {(totalIngredientWeight ?? 0).toFixed(1)} kg
                  </span>
                </div>
              }
            />
          </span>
          <span className="flex items-center space-x-1">
            <Icons.pizza size={16} />
            <Text className="text-right text-sm text-gray-600">
              {product.servings} serving{product.servings > 1 ? 's' : ''}
            </Text>
          </span>
          <span className="flex items-center space-x-1 text-right font-medium text-teal-600">
            <Icons.pieChart size={16} />
            <Text>
              {ingredientShareOfTotalEmissions
                ? `${(ingredientShareOfTotalEmissions * 100).toFixed(1)}%`
                : '0%'}{' '}
              of total emissions
            </Text>
          </span>
        </div>
      </div>
      <ProductIngredientsTable
        product={product}
        ingredients={ingredients}
        maxEmissions={globalMaxEmissions}
      />
    </div>
  );
}
